import React from 'react';

import { Link } from 'react-router-dom';

import { css } from '@emotion/css';
import { RecurrencyRole, TenantUserPermission } from '@recurrency/core-api-schema/dist/common/enums';
import { theme } from 'theme';

import { FlexSpace } from 'components/FlexSpace';
import { BorderedPropertyItem } from 'components/recipes/equation/BorderedPropertyItem';
import { Typography } from 'components/Typography';

import { globalAppStore } from 'hooks/useGlobalApp';

import { formatNumber } from 'utils/formatting';
import { arePermissionsEnabled, hasUserPermission, isRecurrencyRole } from 'utils/roleAndTenant';
import { routes } from 'utils/routes';

export interface RuleOverrideEquationProps {
  type: string;
  value: number;
  uom: string;
}

export const RuleOverrideEquation = ({ type, value, uom }: RuleOverrideEquationProps) => {
  const { activeTenant } = globalAppStore.state;
  const canOpenRuleBuilder = arePermissionsEnabled()
    ? hasUserPermission(activeTenant, TenantUserPermission.AccessRuleBuilderRulesView)
    : isRecurrencyRole(activeTenant, RecurrencyRole.TenantAdmin);
  return (
    <FlexSpace
      direction="column"
      align-items="start"
      className={css`
        align-content: flex-start;
      `}
    >
      <FlexSpace>
        <BorderedPropertyItem
          label={`${type} Calculation`}
          value={`${formatNumber(value)} ${uom}`}
          description={
            <Typography type="small" style={{ color: theme.colors.primary[500] }}>
              {`The ${type} value for this`}
              <br />
              item is being managed via
              {canOpenRuleBuilder ? <Link to={`${routes.ruleBuilder.ruleManagement()}`}> Rules.</Link> : ' Rules.'}
            </Typography>
          }
        />
      </FlexSpace>
    </FlexSpace>
  );
};
